<template>
  <div class="default">
    <img src="../assets/quexing-bg.png" alt="" />
    <p>页面正在准备中，敬请期待</p>
  </div>
</template>

<script>
export default {
  name: "dataefault",
  data() {
    return {};
  },
};
</script>

<style scoped>
.default {
  width: 100%;
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 200px 0;
}
img {
  width: 198px;
  height: 128px;
}
p {
  font-size: 16px;
  font-weight: 400;
  color: #788a9f;
  line-height: 16px;
  margin-top: 20px;
}
</style>
